import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component export class HotspotsCard extends ThemeComponent {

    @Ref() hotspotCard!: HTMLElement[];
    @Ref() hotspot!: HTMLElement[];
    @Ref() hotspotClose!: HTMLElement[];

    init() {
        this.handleHover();
    }

    handleHover() {
        let activeCard: HTMLElement | null = null;

        for (const [index, hotspot] of this.hotspot.entries()) {
            const card = this.hotspotCard[index];

            this.$listen(hotspot, 'mouseover', () => {
                if (activeCard) {
                    activeCard.classList.add('hotspot-product-card__hidden');
                }

                card.classList.remove('hotspot-product-card__hidden');
                activeCard = card;
            });

            this.$listen(card, 'mouseleave', () => {
                card.classList.add('hotspot-product-card__hidden');
            });

            for (const close of this.hotspotClose) {
                this.$listen(close, 'click', () => {

                    card.classList.add('hotspot-product-card__hidden');
                });
            }
        }
    }









}
